// Download quality tiers. The server is authoritative for prices
// (GET /api/pricing); these are the technical specs shared by client + server.

export type TierId = 'preview' | 'hd' | 'ultra';

export interface TierSpec {
  id: TierId;
  name: string;
  /** render scale relative to the base layout size (strip4 = 600×1830 @1x) */
  scale: number;
  watermark: boolean;
  quality: number;
  description: string;
}

export const TIERS: TierSpec[] = [
  { id: 'preview', name: 'Xem trước', scale: 1, watermark: true, quality: 0.72, description: 'Có watermark · xem trên điện thoại' },
  { id: 'hd', name: 'HD', scale: 2, watermark: false, quality: 0.9, description: 'Không watermark · đăng mạng xã hội' },
  { id: 'ultra', name: 'Ultra · In ấn', scale: 3, watermark: false, quality: 0.95, description: 'Độ phân giải cao nhất · in ảnh sắc nét' },
];

export const tierById = (id: string) => TIERS.find((t) => t.id === id);

/** Base size of a single-shot photo at scale 1 (stage aspect 3:4). */
export const SHOT_BASE = { w: 720, h: 960 };

export interface TierPrice {
  id: TierId;
  price: number;
  currency: string;
}
